import type { enStory } from './en.story';

export const zhTWStory: typeof enStory = {
  story: {
    ui: {
      chapter: (n: number) => `第 ${n} 章`,
      locked: '今天還不能進行',
      progress: (done: number, total: number) => `${done}/${total}`,
      offers: '有事找你',
      talk: '去找',
    },
    items: {
      postcard: { name: '臺北明信片', desc: '給李奶奶的。三張不同的湊成一組。' },
      pineappleCake: { name: '鳳梨酥', desc: '一盒臺北買的鳳梨酥，給媽媽。' },
      mochi: { name: '花蓮麻糬', desc: '一盒軟 Q 的麻糬，給小波。今天就要吃！' },
      pebble: { name: '七星潭石頭', desc: '圓圓灰灰的，被太平洋磨得光滑。給小雨。' },
      photo: { name: '象山的照片', desc: '你和臺北 101。給艾瑪。' },
    },
    chapters: {
      school: { title: '開學第一天', hint: '星期五在學校：朋友、老師，還有沒吃早餐的警衛伯伯。' },
      town: { title: '社區的週末', hint: '星期六和星期日在鎮上：走失的小貓、風箏和幸運草。' },
      taipei: { title: '來自臺北的明信片', hint: '到車站搭火車去臺北。每個區都有人託你辦事。' },
      hualien: { title: '太平洋的風', hint: '往東的火車開到花蓮：大理石峽谷、礫石海灘和軟 Q 的麻糬。' },
    },
    quests: {
      postcards: {
        offer: '我年輕的時候一直沒機會去大城市。你可以幫我從臺北寄明信片回來嗎？一張車站、一張龍山寺、一張自由廣場。',
        accept: '我幫奶奶收集三張明信片！',
        collect: {
          guide: '臺北車站的明信片——1941 年落成的紅磚大廳。你看，連時鐘都在上面。',
          xm_volunteer: '龍山寺的明信片。你知道嗎？它是 1738 年由來自福建的移民建造的。',
          ck_guide: '自由廣場白色牌樓的明信片。五個拱門有 30 公尺高呢！',
        },
        ask: '可以給我一張明信片送給奶奶嗎？',
        give: '把三張明信片交給李奶奶',
        thanks: '哎呀……車站、寺廟、大牌樓！好像跟著你一起旅行了。謝謝你，乖孩子。',
      },
      pineapple: {
        offer: '奶奶要來喝茶，她最愛鳳梨酥了。最好吃的在臺北——你去的話可以帶一盒回來嗎？',
        accept: '我會帶一盒鳳梨酥回來！',
        buy: '買一盒鳳梨酥（60🪙）',
        bought: '剛出爐的！奶油酥皮，裡面是鳳梨餡。盒子要平放喔。',
        poor: '一盒要 60 枚硬幣，錢夠了再來吧！',
        give: '把鳳梨酥交給媽媽',
        thanks: '真正的臺北鳳梨酥！奶奶一定會很開心。你真棒。',
      },
      elephant: {
        offer: '學校裡大家都有從象山拍的臺北 101 照片。你可以幫我拍一張嗎？拜託拜託！',
        accept: '我爬上去幫你拍！',
        ask: '可以幫我和臺北 101 拍一張照片嗎？',
        shot: '笑一個！……完美：整個天際線都在你後面。600 階沒白爬。',
        give: '把象山的照片拿給艾瑪看',
        thanks: '哇！整座城市！我要貼在冰箱上。你最棒了！',
      },
      mochi: {
        offer: '我表哥說花蓮麻糬是世界上最軟的東西。你要是去那裡……幫我帶一些？我用最好的彈珠跟你換。',
        accept: '成交。花蓮麻糬，馬上來！',
        buy: '幫小波買一盒麻糬（40🪙）',
        bought: '今天早上才搗的——綠豆、芝麻、花生。今天就要吃掉，放不久喔！',
        poor: '一盒要 40 枚硬幣，小朋友。存夠了再來！',
        give: '把花蓮麻糬交給小波',
        thanks: '好軟喔！拿去，彈珠是你的了。史上最棒的交換。',
      },
      pebble: {
        offer: '我收集全臺灣的石頭。還缺一顆花蓮七星潭的灰色圓石頭。你可以幫我找一顆嗎？',
        accept: '七星潭的石頭，我來找！',
        ask: '我可以拿一顆石頭給朋友收藏嗎？',
        found: '一顆？好吧，只能一顆，而且告訴你朋友，海灘需要其他的石頭。這顆被海水磨了一千年呢。',
        give: '把七星潭的石頭交給小雨',
        thanks: '圓圓的、灰色、像玻璃一樣光滑……太完美了。七星潭，收集完成！謝謝你！',
      },
    },
  },
};
